import { defineStore } from 'pinia';

import type { BaseModel } from '~/diptyqueTheme/types/contentful';

interface CachedItem extends BaseModel {
  [key: string]: unknown;
}

interface ContentfulStore {
  cache: Record<string, CachedItem>;
}

export const useContentfulStore = defineStore('contentful', {
  state: (): ContentfulStore => ({
    cache: {}
  }),
  getters: {
    get:
      (state) =>
      (id: string): CachedItem | undefined => {
        return state.cache[id];
      }
  },
  actions: {
    put(item: CachedItem) {
      this.cache[item.sys.id] = item;
    }
  }
});
